module.exports = __webpack_public_path__ + "img/jpeg.0fee9530.png";